/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0
};
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiRoleList, apiRoleDelete } from '@/api/user';
import AddEditRoleGroup from './module/addEditRoleGroup.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'roleGroup',
  props: {
    active: {
      type: String,
      default: ''
    }
  },
  emits: ['onActive'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const operateType = ref('add');
    const roleId = ref(0);
    const columns = [{
      label: '角色组',
      prop: 'Name'
    }, {
      label: '创建者',
      prop: 'UserName'
    }, {
      label: '人数',
      prop: 'CreatedRolesNum',
      slot: 'CreatedRolesNum'
    }, {
      label: '备注',
      prop: 'Remark'
    }, {
      label: '操作',
      action: true
    }];
    const getTableData = () => {
      apiRoleList({
        Page: current.value,
        PageSize: pageSize.value
      }).then(res => {
        if (res.code === 0 && res.data) {
          tableData.value = res.data;
          total.value = res.pageTotal;
        } else {
          res.data = [];
        }
      });
    };
    const handleClick = (type, data) => {
      if (type === 'add') {
        operateType.value = 'add';
        emits('onActive', 'addEditRoleGroup', 'add');
        roleId.value = 0;
      } else if (type === 'edit') {
        roleId.value = data.Id;
        operateType.value = 'edit';
        emits('onActive', 'addEditRoleGroup', 'edit');
      } else if (type === 'check') {
        roleId.value = data.Id;
        operateType.value = 'check';
        emits('onActive', 'addEditRoleGroup', 'check');
      } else {
        ElMessageBox.confirm('删除该组成员将无法登录，你还要继续吗？', '是否要删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiRoleDelete({
            RoleId: data.Id
          }).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
        }).catch(() => {
          //
        });
      }
    };
    const handleSuccess = type => {
      emits('onActive', type);
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    watch(() => props.active, val => {
      if (val === 'roleGroup') {
        getTableData();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_u_card_pane, {
        name: "roleGroup"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_Teleport, {
          to: "#roleGroup"
        }, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleClick('add'))
        }, {
          default: _withCtx(() => [_createTextVNode("添加角色组")]),
          _: 1
        })])), _createVNode(UTable, {
          options: columns,
          data: _unref(tableData),
          loading: _unref(tableLoading),
          pagination: "",
          "current-page": _unref(current),
          "page-size": _unref(pageSize),
          total: _unref(total),
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange)
        }, {
          action: _withCtx(({
            scope
          }) => [scope.row.IsDisplay === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            onClick: $event => handleClick('edit', scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            onClick: $event => handleClick('check', scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("详情")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "danger",
            onClick: $event => handleClick('del', scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      }), _createVNode(AddEditRoleGroup, {
        active: __props.active,
        type: _unref(operateType),
        roleId: _unref(roleId),
        onSuccess: handleSuccess
      }, null, 8, ["active", "type", "roleId"])], 64);
    };
  }
});